import { render, staticRenderFns } from "./quotaDetails.vue?vue&type=template&id=789a1d00&scoped=true&"
import script from "./quotaDetails.vue?vue&type=script&lang=js&"
export * from "./quotaDetails.vue?vue&type=script&lang=js&"
import style0 from "./quotaDetails.vue?vue&type=style&index=0&id=789a1d00&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a1d00",
  null
  
)

export default component.exports